import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const EXTERNAL_CODE_GENERATOR_API_URL = `${API_HOST}/api/externalCodeGenerator`;

function* createRelayItem() {
  yield takeEvery(actions.CREATE_EXTERNAL_CODE_GENERATOR, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], EXTERNAL_CODE_GENERATOR_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_EXTERNAL_CODE_GENERATOR_ENDED });
    }
  });
}

function* searchExternalCodeGenerators() {
  yield takeEvery(actions.SEARCH_EXTERNAL_CODE_GENERATORS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EXTERNAL_CODE_GENERATOR_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXTERNAL_CODE_GENERATORS_ENDED });
    }
  });
}

function* updateExternalCodeGenerator() {
  yield takeEvery(actions.UPDATE_EXTERNAL_CODE_GENERATOR, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], EXTERNAL_CODE_GENERATOR_API_URL, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EXTERNAL_CODE_GENERATOR_ENDED });
    }
  });
}

function* deleteExternalCodeGenerators() {
  yield takeEvery(actions.DELETE_EXTERNAL_CODE_GENERATOR, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], EXTERNAL_CODE_GENERATOR_API_URL, {
        data,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_EXTERNAL_CODE_GENERATOR_ENDED });
    }
  });
}

function* updateExternalCodeGeneratorBrandFields() {
  yield takeEvery(actions.UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${EXTERNAL_CODE_GENERATOR_API_URL}/brandFields`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED });
    }
  });
}

function* searchExternalCodeGeneratorBrandFields() {
  yield takeEvery(actions.SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${EXTERNAL_CODE_GENERATOR_API_URL}/brandFields?${parameters.toString()}`,
      );

      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createRelayItem),
    fork(searchExternalCodeGenerators),
    fork(updateExternalCodeGenerator),
    fork(deleteExternalCodeGenerators),
    fork(updateExternalCodeGeneratorBrandFields),
    fork(searchExternalCodeGeneratorBrandFields),
  ]);
}
